import * as React from "react";

export default function AccessToPatientCardAction({ url }: { url: string }) {
  return (
    <a className="button-secondary" href={url} target="_self">
      <span>{i18n["Page.PatientManagement.Profile.AccessPatientCard"]}</span>
    </a>
  );
}
